/** A fixed palette, not free-form colour. The point of a label is that two things
 *  wearing the same one look the same at a glance, so the set is small, named,
 *  and the same set the server validates against (api/projects.py LABEL_COLORS).
 *  Shared by the hub's audio files and the Workflows board's rows, so a colour
 *  means the same in both. "" is no label, and is the default — it has to stay
 *  distinguishable from a colour, not be one. */
export const LABELS: { key: string; name: string; dot: string }[] = [
  { key: "", name: "No colour", dot: "" },
  { key: "red", name: "Red", dot: "#E23054" },
  { key: "amber", name: "Amber", dot: "#E0890A" },
  { key: "green", name: "Green", dot: "#18A97A" },
  { key: "blue", name: "Blue", dot: "#2540F6" },
  { key: "purple", name: "Purple", dot: "#8312E0" },
  { key: "grey", name: "Grey", dot: "#8A90AC" },
];
export const labelDot = (key?: string) => LABELS.find((l) => l.key === (key || ""))?.dot || "";
export const labelName = (key?: string) => LABELS.find((l) => l.key === (key || ""))?.name || "No colour";
